import React from 'react';
import { CURATOR_URLS, useCurator } from '@noths/polaris-client-site-chrome-ui';
import dynamic from 'next/dynamic';

import { isProd } from 'src/environment';
import type { ContentPageProps } from 'src/types/PageProps';

const baseUrl = isProd() ? CURATOR_URLS.BASE_URL_PROD : CURATOR_URLS.BASE_URL_QA;
const streamUrl = isProd() ? CURATOR_URLS.STREAM_URL_PROD : CURATOR_URLS.STREAM_URL_QA;

const Curator = dynamic(
  () =>
    import('@noths/curator-web').then(async (m) => {
      m.configureCurator({
        baseUrl,
        streamUrl,
      });
      return m.Curator;
    }),
  { ssr: false },
);

interface CuratorWrapperProps {
  siteChromeContent?: ContentPageProps['siteChromeContent'];
}

export const CuratorWrapper = ({ siteChromeContent }: CuratorWrapperProps) => {
  const showCurator = siteChromeContent?.enableCurator ?? false;
  const { handleToggle, isCuratorOpen, redirectToPDP } = useCurator();

  if (!showCurator) {
    return null;
  }

  return <Curator isOpen={isCuratorOpen} onToggle={handleToggle} productClick={redirectToPDP} />;
};
